<section id="content">
  <app-wallet-bar *ngIf="(isLoggedIn$ | async)"></app-wallet-bar>
  <router-outlet></router-outlet>
</section>

<app-footer-wrapper></app-footer-wrapper>
